// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"633":"6333b546","875":"6333b546"}[chunkId] + ".chunk.css";
};